import script from "./SplitCardModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SplitCardModal.vue?vue&type=script&setup=true&lang=js"

import "./SplitCardModal.vue?vue&type=style&index=0&id=7b9346c8&lang=sass&scoped=true"

import exportComponent from "/home/goran/projects/plodine/plodine/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b9346c8"]])

export default __exports__